
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const trackingSteps = [
  {
    id: 1,
    title: 'تم استلام الطلب',
    description: 'تم استلام طلبك بنجاح',
    icon: 'ri-checkbox-circle-fill',
    time: '10:30 ص'
  },
  {
    id: 2,
    title: 'جاري التوجه',
    description: 'الفني في الطريق إليك',
    icon: 'ri-car-fill',
    time: '11:00 ص'
  },
  {
    id: 3,
    title: 'جاري العمل',
    description: 'بدأ الفني بتنفيذ الخدمة',
    icon: 'ri-tools-fill',
    time: ''
  },
  {
    id: 4,
    title: 'مكتمل',
    description: 'تم إنجاز الخدمة بنجاح',
    icon: 'ri-check-double-fill',
    time: ''
  }
];

export default function OrderTracking() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(2);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (currentStep < 4) {
        setCurrentStep(currentStep + 1);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, [currentStep]);

  const handleComplete = () => {
    navigate('/payment');
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-6">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-6 px-6 rounded-b-[30px]">
        <div className="flex items-center gap-3 mb-4 animate-fadeIn">
          <button onClick={() => navigate('/home')} className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          <div className="flex-1">
            <h1 className="text-xl font-bold text-white">متابعة الطلب</h1>
            <p className="text-white/80 text-sm mt-1">رقم الطلب: #12345</p>
          </div>
        </div>
      </div>

      {/* Technician Card */}
      <div className="px-6 -mt-4">
        <div className="bg-white rounded-2xl p-4 shadow-lg animate-slideUp">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-14 h-14 rounded-full overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/fb9f3c4720c66a4e5914734b1fd15792.jpg"
                alt="الفني"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#212121]">أحمد محمد</h3>
              <div className="flex items-center gap-1 mt-1">
                <i className="ri-star-fill text-[#FBC02D] text-xs"></i>
                <span className="text-sm font-semibold">4.9</span>
                <span className="text-gray-400 text-xs">(156 تقييم)</span>
              </div>
            </div>
            <div className="flex gap-2">
              <button className="w-10 h-10 bg-[#2E7D32] rounded-xl flex items-center justify-center">
                <i className="ri-phone-fill text-white"></i>
              </button>
              <button className="w-10 h-10 bg-[#1565C0] rounded-xl flex items-center justify-center">
                <i className="ri-message-3-fill text-white"></i>
              </button>
            </div>
          </div>

          {/* ETA */}
          <div className="bg-[#F6F6F6] rounded-xl p-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-[#2E7D32]/10 rounded-lg flex items-center justify-center">
                <i className="ri-time-line text-[#2E7D32]"></i>
              </div>
              <span className="text-sm text-gray-600">الوقت المتوقع للوصول</span>
            </div>
            <span className="text-lg font-bold text-[#2E7D32]">15 دقيقة</span>
          </div>
        </div>
      </div>

      {/* Tracking Timeline */}
      <div className="px-6 mt-6">
        <div className="bg-white rounded-2xl p-5 shadow-md animate-slideUp stagger-1">
          <h3 className="font-bold text-[#212121] mb-4">حالة الطلب</h3>
          
          <div className="space-y-4">
            {trackingSteps.map((step, index) => {
              const isCompleted = index < currentStep;
              const isCurrent = index === currentStep;
              
              return (
                <div key={step.id} className="flex gap-3">
                  {/* Timeline Line */}
                  <div className="flex flex-col items-center">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
                        isCompleted || isCurrent
                          ? 'bg-[#2E7D32] text-white'
                          : 'bg-gray-200 text-gray-400'
                      } ${isCurrent ? 'animate-pulse-soft' : ''}`}
                    >
                      <i className={`${step.icon} text-lg`}></i>
                    </div>
                    {index < trackingSteps.length - 1 && (
                      <div
                        className={`w-0.5 h-12 transition-all ${
                          isCompleted ? 'bg-[#2E7D32]' : 'bg-gray-200'
                        }`}
                      ></div>
                    )}
                  </div>

                  {/* Step Info */}
                  <div className="flex-1 pb-4">
                    <div className="flex items-center justify-between mb-1">
                      <h4
                        className={`font-bold ${
                          isCompleted || isCurrent ? 'text-[#212121]' : 'text-gray-400'
                        }`}
                      >
                        {step.title}
                      </h4>
                      {step.time && (
                        <span className="text-xs text-gray-400">{step.time}</span>
                      )}
                    </div>
                    <p
                      className={`text-sm ${
                        isCompleted || isCurrent ? 'text-gray-600' : 'text-gray-400'
                      }`}
                    >
                      {step.description}
                    </p>
                    {isCurrent && (
                      <div className="mt-2 flex items-center gap-2">
                        <div className="flex gap-1">
                          <div className="w-1.5 h-1.5 bg-[#2E7D32] rounded-full animate-bounce"></div>
                          <div className="w-1.5 h-1.5 bg-[#2E7D32] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                          <div className="w-1.5 h-1.5 bg-[#2E7D32] rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
                        </div>
                        <span className="text-xs text-[#2E7D32] font-semibold">جاري التنفيذ</span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Service Details */}
      <div className="px-6 mt-4">
        <div className="bg-white rounded-2xl p-5 shadow-md animate-slideUp stagger-2">
          <h3 className="font-bold text-[#212121] mb-3">تفاصيل الخدمة</h3>
          
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">نوع الخدمة</span>
              <span className="text-sm font-semibold text-[#212121]">تمريض منزلي</span>
            </div>
            <div className="h-px bg-gray-100"></div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">التاريخ</span>
              <span className="text-sm font-semibold text-[#212121]">15 يناير 2024</span>
            </div>
            <div className="h-px bg-gray-100"></div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">الوقت</span>
              <span className="text-sm font-semibold text-[#212121]">11:00 ص</span>
            </div>
            <div className="h-px bg-gray-100"></div>
            <div className="flex items-start justify-between">
              <span className="text-sm text-gray-600">العنوان</span>
              <span className="text-sm font-semibold text-[#212121] text-left">حي النخيل، الرياض</span>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      {currentStep === 4 && (
        <div className="px-6 mt-4 animate-slideUp">
          <button
            onClick={handleComplete}
            className="w-full bg-gradient-to-l from-[#1565C0] to-[#2E7D32] text-white py-4 rounded-xl font-bold shadow-lg hover:shadow-xl transition-all active:scale-[0.98]"
          >
            متابعة للدفع
          </button>
        </div>
      )}
    </div>
  );
}
